import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import { notify } from '../../../../utils/notification'
import webTokenStorer from '../../../../utils/webStorer';
import * as  req from '../../../../axios/request/AuthReqs/AdminLoginReqs/authReq'
// import { getFirebaseURL } from '../../../firebase/firebaseFunction';
function* register(action) {
    try {
        const result = yield call(req.registerReq, action);
        if (result.success === true) {
            notify('success', result.message);
            yield put({ type: types.ADMIN_REGISTER_SUCCESS, payload: result.data });
            action?.data?.clearForm();
        } else {
            yield put({ type: types.ADMIN_REGISTER_FAILURE, message: result?.message });
        }
    } catch (e) {
        console.log(e)
    }
}

function* login(action) {
    try {
        const result = yield call(req.loginReq, action);
        // console.log(result)
        if (result.success === true) {
            notify('success', result.message);
            webTokenStorer.saveToken2({
                access_token: result.data.token,
                society_id: result.data?.user?.community_id || 0,
                user_id: result.data?.user?.user_id || 0,
                user_role: result.data.role,
                rememberMe: action.data?.rememberMe || 0
            })
            yield put({ type: types.ADMIN_LOGIN_SUCCESS, payload: result.data });
            action?.data?.onSuccess();
        } else {
            notify('error', result?.response?.data?.message);
            yield put({ type: types.ADMIN_LOGIN_FAILURE, message: result?.message });
        }
        // // if (result.statusCode === 200) {
        // //     webTokenStorer.saveToken({
        // //         access_token: result.data.access_token,
        // //         society_id: result.data?.default_community?.community_id,
        // //         user_role: result.data.user_role,
        // //         house_unique_id: result.data?.default_community?.blocks?.[0]?.houseUniqueId || 0,
        // //         rememberMe: action.data.rememberMe

        // //     })
        // //     const reloginResult = yield call(req.reloginReq, {
        // //         data: {
        // //             society_id: result.data?.default_community?.community_id,
        // //             house_unique_id: result.data?.default_community?.blocks?.[0]?.houseUniqueId || 0,
        // //             user_role: result.data.user_role,
        // //             firstLogin: true,
        // //             ipAddress: action.data?.ipAddress,
        // //             pwd: result.data.pwd,
        // //         }
        // //     });

        // //     if (reloginResult.statusCode === 200) {
        // //         // reloginResult.data.default_community.profile_photo_url = yield getFirebaseURL(result.data.default_community?.profile_photo)

        // //         webTokenStorer.saveToken({
        // //             access_token: reloginResult.data.access_token,
        // //             society_id: reloginResult.data.default_community?.community_id,
        // //             house_unique_id: reloginResult.data?.default_community?.blocks?.houseUniqueId || 0,
        // //             user_role: reloginResult.data.user_type,
        // //             pwd: reloginResult.data.pwd
        // //             //rememberMe: action.data.rememberMe
        // //         })
        // //         if (action.data.rememberMe)
        // //             webCredentialsStorer.saveCredentials({ id: action.data.email, pwd: action.data.password })

        // //         yield put({ type: types.LOGIN_SUCCESS, payload: reloginResult.data });
        // //         action.data?.onSuccessCallback()
        // //         notify('success', reloginResult.message);
        // //     }
        // //     else {
        // //         webTokenStorer.removeToken()
        // //         yield put({ type: types.LOGIN_FAILURE, message: result?.response?.data?.message });
        // //     }
        // } else {
        //     webTokenStorer.removeToken()
        //     yield put({ type: types.LOGIN_FAILURE, message: result?.response?.data?.message });
        // }
    } catch (e) {
        console.log(e)
    }
}

function* logout(action) {
    try {
        const result = yield call(req.logoutReq, action);
        if (result.success === true) {
            webTokenStorer.removeToken()
            notify('success', 'Logged out successfully');
            action?.data?.redirect()
            // navigate(SOCIETY_CONTROLLER + LOGIN)
            // result.data.default_community.profile_photo_url = yield getFirebaseURL(result.data.default_community?.profile_photo)

            yield put({ type: types.ADMIN_LOGIN_SUCCESS, payload: '' });
        } else {
            yield put({ type: types.ADMIN_LOGIN_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
    }
}

function* relogin(action) {
    try {
        const result = yield call(req.reloginReq, action);
        if (result.success === true) {
            webTokenStorer.saveToken2({
                access_token: result.data.token,
                society_id: result.data?.user?.community_id || 0,
                user_id: result.data?.user?.user_id || 0,
                user_role: result.data.role,
                rememberMe: action.data?.rememberMe || 0
            })
            action.data?.onSuccessCallback?.()
            // result.data.default_community.profile_photo_url = yield getFirebaseURL(result.data.default_community?.profile_photo)

            yield put({ type: types.ADMIN_RELOGIN_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.ADMIN_RELOGIN_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        console.log(e)
    }
}


export default function* adminLoginSaga() {
    yield takeLatest(types.ADMIN_REGISTER, register);
    yield takeLatest(types.ADMIN_LOGIN, login);
    yield takeLatest(types.ADMIN_LOGOUT, logout);
    yield takeLatest(types.ADMIN_RELOGIN, relogin);
}